module.exports = __webpack_public_path__ + "static/media/Story-Research-DomainMap.5959c468.svg";